/**
 * FAQ Categories: icon nav anchors + scroll spy active state.
 */
(function () {
  function getOffset() {
    const headerOffset = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-bottom-position')
    );
    return (Number.isFinite(headerOffset) ? headerOffset : 76) + 16;
  }

  function initRoot(root) {
    const navItems = Array.from(root.querySelectorAll('[data-faq-categories-nav-item]'));
    const groups = Array.from(root.querySelectorAll('[data-faq-categories-group]'));
    if (!navItems.length || !groups.length) return;

    let ticking = false;

    function setActive(handler) {
      navItems.forEach((item) => {
        const isActive = item.getAttribute('data-faq-categories-nav-item') === handler;
        item.classList.toggle('is-active', isActive);
        if (isActive) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
    }

    function updateActiveFromScroll() {
      const offset = getOffset();
      let current = groups[0]?.getAttribute('data-faq-categories-group');

      groups.forEach((group) => {
        const top = group.getBoundingClientRect().top;
        if (top - offset <= 0) {
          current = group.getAttribute('data-faq-categories-group');
        }
      });

      if (current) setActive(current);
    }

    function scrollToGroup(targetId) {
      const target = root.querySelector(`#${CSS.escape(targetId)}`);
      if (!target) return;
      const offset = getOffset();
      const top = window.scrollY + target.getBoundingClientRect().top - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    navItems.forEach((item) => {
      item.addEventListener('click', (event) => {
        const targetId = item.getAttribute('data-faq-categories-target');
        if (!targetId) return;
        event.preventDefault();
        setActive(item.getAttribute('data-faq-categories-nav-item'));
        scrollToGroup(targetId);
        if (history.replaceState) {
          history.replaceState(null, '', `#${targetId}`);
        }
      });
    });

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          updateActiveFromScroll();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', updateActiveFromScroll, { passive: true });

    const hashId = window.location.hash.replace(/^#/, '');
    if (hashId && root.querySelector(`#${CSS.escape(hashId)}`)) {
      const match = navItems.find((item) => item.getAttribute('data-faq-categories-target') === hashId);
      if (match) setActive(match.getAttribute('data-faq-categories-nav-item'));
      window.requestAnimationFrame(() => scrollToGroup(hashId));
    } else {
      updateActiveFromScroll();
    }
  }

  function init() {
    document.querySelectorAll('[data-faq-categories]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root =
      event.target.querySelector?.('[data-faq-categories]') ||
      event.target.closest?.('[data-faq-categories]');
    if (root) initRoot(root);
  });
})();
